export const domain = 'Notifications';

// action types
export const OPEN_SNACKBAR = `${domain}/OPEN_SNACKBAR`;
export const CLOSE_SNACKBAR = `${domain}/CLOSE_SNACKBAR`;
export const RESUME_SNACKBAR = `${domain}/RESUME_SNACKBAR`;
export const CREATE_NOTIFICATION = `${domain}/CREATE_NOTIFICATION`;
